export const KCM_2000_COMPANY = 'КЦМ 2000';
export const KCM_AD_COMPANY = 'КЦМ АД';
export const LEGACY_METALURG21_COMPANY = 'Металургремонт 21 ЕАД';
export const METALURG21_COMPANY = 'Металургремонт 21 ЕООД';
export const KIS_COMPANY = 'Комплексен индустриален сервиз ЕООД';
export const KCM_TECHNOLOGY_COMPANY = 'КЦМ Технолоджи ЕООД';
export const STOPANSKI_DEYNOSTI_COMPANY = 'Стопански дейности КЦМ ЕООД';
export const STROYSERVICE_COMPANY = 'Стройсервиз ЕООД';
export const KCM_TRADE_COMPANY = 'КЦМ Трейд ЕООД';

export function normalizeCompany(company) {
  return company === LEGACY_METALURG21_COMPANY ? METALURG21_COMPANY : company;
}

export const TRDOSIE_COMPANIES = [
  KCM_AD_COMPANY,
  METALURG21_COMPANY,
  KIS_COMPANY,
];

export const KCM_AD_LIKE_COMPANIES = [
  KCM_AD_COMPANY,
  METALURG21_COMPANY,
  KIS_COMPANY,
  KCM_TECHNOLOGY_COMPANY,
  STOPANSKI_DEYNOSTI_COMPANY,
  STROYSERVICE_COMPANY,
];

export const SCHEDULE_COMPANIES = [
  ...KCM_AD_LIKE_COMPANIES,
  KCM_TRADE_COMPANY,
];

export const HOURLY_ABSENCE_COMPANIES = [
  ...KCM_AD_LIKE_COMPANIES,
  KCM_2000_COMPANY,
];

export const MANUAL_EMPLOYEE_COMPANIES = [
  KCM_2000_COMPANY,
  KCM_TECHNOLOGY_COMPANY,
  STOPANSKI_DEYNOSTI_COMPANY,
  STROYSERVICE_COMPANY,
  KCM_TRADE_COMPANY,
];

export const EDITABLE_MANUAL_EMPLOYEE_COMPANIES = [
  KCM_TECHNOLOGY_COMPANY,
  STOPANSKI_DEYNOSTI_COMPANY,
  STROYSERVICE_COMPANY,
  KCM_TRADE_COMPANY,
];

export const NEW_COMPANY_EGN_REQUIRED_COMPANIES = [
  KCM_TECHNOLOGY_COMPANY,
  STOPANSKI_DEYNOSTI_COMPANY,
  STROYSERVICE_COMPANY,
  KCM_TRADE_COMPANY,
];

export const SELECT_COMPANIES = [
  KCM_AD_COMPANY,
  KCM_2000_COMPANY,
  METALURG21_COMPANY,
  KIS_COMPANY,
  KCM_TECHNOLOGY_COMPANY,
  STOPANSKI_DEYNOSTI_COMPANY,
  STROYSERVICE_COMPANY,
  KCM_TRADE_COMPANY,
  'Индустриална зона КЦМ ЕООД',
  'Лъки Инвест АД',
  'Върба-Батанци АД',
  'BLZ Metalikon Ltd',
  'MCM BV',
];

export const ACTIVE_COMPANIES = [
  KCM_AD_COMPANY,
  KCM_2000_COMPANY,
  METALURG21_COMPANY,
  KIS_COMPANY,
  KCM_TECHNOLOGY_COMPANY,
  STOPANSKI_DEYNOSTI_COMPANY,
  STROYSERVICE_COMPANY,
  KCM_TRADE_COMPANY,
];

export const NAV_COMPANIES = [
  { name: 'КЦМ АД', value: KCM_AD_COMPANY },
  { name: 'МР 21', value: METALURG21_COMPANY },
  { name: 'КИС', value: KIS_COMPANY },
  { name: 'КЦМ Технолоджи', value: KCM_TECHNOLOGY_COMPANY },
  { name: 'Стопански дейности', value: STOPANSKI_DEYNOSTI_COMPANY },
  { name: 'Стройсервиз', value: STROYSERVICE_COMPANY },
  { name: 'КЦМ Трейд', value: KCM_TRADE_COMPANY },
  { name: 'КЦМ 2000', value: KCM_2000_COMPANY },
];

export const PERMISSION_COMPANIES = [
  { name: KCM_AD_COMPANY, value: KCM_AD_COMPANY },
  { name: KCM_2000_COMPANY, value: KCM_2000_COMPANY },
  { name: METALURG21_COMPANY, value: METALURG21_COMPANY },
  { name: KIS_COMPANY, value: KIS_COMPANY },
  { name: KCM_TECHNOLOGY_COMPANY, value: KCM_TECHNOLOGY_COMPANY },
  { name: STOPANSKI_DEYNOSTI_COMPANY, value: STOPANSKI_DEYNOSTI_COMPANY },
  { name: STROYSERVICE_COMPANY, value: STROYSERVICE_COMPANY },
  { name: KCM_TRADE_COMPANY, value: KCM_TRADE_COMPANY },
];

export function isCompanyIn(companies, company) {
  return companies.indexOf(company) > -1;
}
